import React from "react";
import getContainerSizeClass from "@root/helpers/get-container-size-class";
import GridTable from "@root/_components/grid-table";

const InfluencersVideoGrid = ({ data }) => {
    const classes = getContainerSizeClass(data?.moduleSettings);
    
    const items = data?.items || [];

    const gridItems = items.map((item) => ({
        image: item.image,
        video: item.video || null,
        text: item.text || "",
        colSpan: item.colSpan || undefined,
    }));

    if (gridItems.length === 0) {
        return null;
    }

    return (
        <div className={`influencers-video-grid ${classes.join(" ")}`}>
            {data?.title && (
                <h2 className="influencers-video-grid__title">{data?.title}</h2>
            )}
            {data?.subtitle && (
                <p className="influencers-video-grid__subtitle">{data?.subtitle}</p>
            )}
            <div className="influencers-video-grid__grid">
                <GridTable items={gridItems} />
            </div>
        </div>
    );
};

export default InfluencersVideoGrid;
